export interface DocumentInterface {
    document_id: number;
    folder_id: number;
    title: string;
    path: string;
    created_datatime: string;
}

export const mapDocument = (data: any): DocumentInterface => {
    if (!data) {
        throw new Error('Invalied Document type')
    }

    const document: DocumentInterface = {
        document_id: data.document_id,
        folder_id: data.folder_id,
        title: data.title,
        path: data.path,
        created_datatime: data.created_datatime,
    }

    return document;
}

export const mapDocuments = (data: any[]): DocumentInterface[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Document data');
    }

    return data.map(mapDocument);
};